// core
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// campfire
import { MatDialog } from '@campfire-nx/material';
import { IArrangementFeeBanner, RaptorDataService } from 'libs/raptor/src/lib/services/raptor-data.service';
import { 
  PartnerBrandService,
  ConfigService,
  TrustpilotService 
} from '@campfire-nx/api';

// components
import { ComparisonModalComponent } from '../modals/comparison-modal/comparison-modal.component';

@Component({
  selector: 'app-refer-generic-car',
  templateUrl: './refer-generic-car.component.html',
  styleUrls: ['./refer-generic-car.component.scss']
})
export class ReferGenericCarComponent implements OnInit {

  trustPilotConfig!: any;
  quote!: any;
  reference!: any;
  cover!: any;
  price: any = {
    currency: '$',
    amount: 0,
    frequency: 'year'
  };
  precision: number = 2;
  vehicle!: string;
  arrangementFeeBanner: IArrangementFeeBanner | null = null;
  additionalChargesDisclaimers: Array<any> = [];

  constructor(
    private route: ActivatedRoute,
    private trustpilotService: TrustpilotService,
    private configService: ConfigService,
    private raptorDataService: RaptorDataService,
    private partnerBrandService: PartnerBrandService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    const trustpilotOptions = {
      trustboxTemplate: this.configService?.data?.trustpilot?.trustboxMicro,
      businessunitId: this.configService?.data?.trustpilot?.huddleBusinessId
    };

    if (this.route.snapshot.data.reference) {
      this.reference = this.route.snapshot.data.reference;
      this.quote = this.formatQuote(this.reference.quote);
      this.vehicle = [
        this.quote.human.vehicle.model,
        this.quote.human.vehicle.description,
        this.quote.human.vehicle.variant,
        this.quote.human.vehicle.series,
        this.quote.human.vehicle.transmission
      ].join(' - ');
    }

    if (this.quote.covers && this.quote.covers[0].has_additional_charges) {
      this.getPolicyArrangementBannerDisclaimer();
    }

    this.trustpilotService.init(['trustbox-rating-1', 'trustbox-rating-2'], trustpilotOptions);
  }

  formatQuote(quote: any) {
    this.calculateTotalPayable(quote)
    return quote;
  }

  calculateTotalPayable(quote: any) : void {
    let selectedCover;
    let product_slug = quote.data['product_slug'];
    let cover_type = quote.data['cover_type'];
    let cover_level = quote.data['cover_level'];
    let frequency = quote.data['frequency'];

    if (quote.covers && Array.isArray(quote.covers)) {
      selectedCover = quote.covers.find((coverItem: any) => {
        return coverItem.cover.product_slug === product_slug &&
          coverItem.cover.cover_type === cover_type &&
          coverItem.cover.cover_level === cover_level
      });
    }

    if (selectedCover) {
      let premiumAttr = 'payable';

      if (frequency === 'U') {
        this.price.frequency = 'year';
        premiumAttr = 'payable';
      }
      if (frequency === 'M') {
        this.price.frequency = 'month';
        premiumAttr = 'payable_monthly';
      }
      this.price.amount = selectedCover.premium[frequency] && selectedCover.premium[frequency][premiumAttr];
    }
    this.price.currency = this.partnerBrandService.getCurrencySymbol();
  }

  public showComparison() {
    this.dialog.open(ComparisonModalComponent, {
      width: '100%',
      height: '100%',
      data: {}
    });
  }

  getPolicyArrangementBannerDisclaimer(): any {
    const { frequency } = this.quote.data;
    const { premium } = this.quote.covers[0];
    const disclaimers = this.raptorDataService.mapBannerDisclaimers(this.quote.covers);

    this.additionalChargesDisclaimers = this.raptorDataService.getIncludedExtrasDisclaimers(premium[frequency].extras);

    this.arrangementFeeBanner = this.raptorDataService.getArrangementFeeBanner(premium, disclaimers, frequency, false);
  }
}